import { GET } from '../request'

export const getEvaluacionesAlumno = ({ alumnoId, mes }) =>
  GET('/api/agora/alumnos/evaluacion-alumnos/list/alumno', {
    alumno: alumnoId,
    mes
  })
